export { default, getStaticProps, getStaticPaths } from "./[...pageSlug]";